import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import API_BASE_URL from "../../../helper.js";

// Success Modal Function
function showSuccessModal(message) {
  $("#successMessage").text(message);
  const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
  modal.show();
}

// ✅ MOVE OUTSIDE
function loadAllGroupImgs() {
  $.ajax({
    url: `${API_BASE_URL}/api/group/all`,
    type: "GET",
    success: function (groups) {
      let rows = "";
      groups.forEach((g, i) => {
        rows += `
          <tr>
            <td>${i + 1}</td>
            <td><img src="${API_BASE_URL}/assets/Images/${g.image}" width="80" /></td>
            <td>
              <button class="btn btn-danger btn-sm deleteGroupImg" data-id="${g.id}">
                Delete
              </button>
            </td>
          </tr>
        `;
      });
      $("#allGroupImgData").html(rows);
    }
  });
}

// ✅ EXPOSE
window.loadGroups = function () {
  loadAllGroupImgs();
};

$(document).ready(function () {

  // ADD Group
  $("#addGroupImgForm").submit(function (e) {
    e.preventDefault();

    const formData = new FormData();
    formData.append("image", $("#image")[0].files[0]);

    $.ajax({
      url: `${API_BASE_URL}/api/group/add`,
      type: "POST",
      data: formData,
      contentType: false,
      processData: false,
      success: function () {
        showSuccessModal("Group Image Added Successfully!");
        $("#addGroupImgForm")[0].reset();

        const modal = window.bootstrap.Modal.getInstance(document.getElementById("groupImgModal"));
        modal.hide();

        loadAllGroupImgs();
      }
    });
  });

  // DELETE Group Image
  $(document).on("click", ".deleteGroupImg", function () {
    let id = $(this).data("id");

    if (!window.confirm("Are you sure want to delete this Group Image?")) return;

    $.ajax({
      url: `${API_BASE_URL}/api/group/delete/${id}`,
      type: "DELETE",
      success: function () {
        showSuccessModal("Group Image Deleted Successfully!");
        loadAllGroupImgs();
      }
    });
  });

});

// import $ from "jquery";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import API_BASE_URL from "../../../helper.js";

// // Success Modal Function
// function showSuccessModal(message) {
//   $("#successMessage").text(message);
//   const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
//   modal.show();
// }

// window.loadGroups = function () {
//     loadAllGroupImgs();
// };

// $(document).ready(function () {

//   // ADD Group
//   $("#addGroupImgForm").submit(function (e) {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append("image", $("#image")[0].files[0]);

//     $.ajax({
//       url: `${API_BASE_URL}/api/group/add`,
//       type: "POST",
//       data: formData,
//       contentType: false,
//       processData: false,
//       success: function () {
//         showSuccessModal("Group Image Added Successfully!");
//         $("#addGroupImgForm")[0].reset();

//         const modal = window.bootstrap.Modal.getInstance(document.getElementById("groupImgModal"));
//         modal.hide();

//         loadAllGroupImgs();
//       }
//     });
//   });

//   // LOAD ALL Group IMAGES
//   function loadAllGroupImgs() {
//     $.ajax({
//       url: `${API_BASE_URL}/api/group/all`,
//       type: "GET",
//       success: function (groups) {
//         let rows = "";
//         groups.forEach((g, i) => {
//           rows += `
//             <tr>
//               <td>${i + 1}</td>
//               <td><img src="${API_BASE_URL}/assets/Images/${g.image}" width="80" /></td>
//               <td>
//                 <button class="btn btn-danger btn-sm deleteGroupImg" data-id="${g.id}">
//                   Delete
//                 </button>
//               </td>
//             </tr>
//           `;
//         });
//         $("#allGroupImgData").html(rows);
//       }
//     });
//   }

//   // DELETE Group Image
//   $(document).on("click", ".deleteGroupImg", function () {
//     let id = $(this).data("id");

//     if (!window.confirm("Are you sure want to delete this Group Image?")) return;

//     $.ajax({
//       url: `${API_BASE_URL}/api/group/delete/${id}`,
//       type: "DELETE",
//       success: function () {
//         showSuccessModal("Group Image Deleted Successfully!");
//         loadAllGroupImgs();
//       }
//     });
//   });

// });
